"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const forms_1 = require("../forms");
const AuthorizedLink_1 = __importDefault(require("./AuthorizedLink"));
const ApplicationActivityTable = ({ data, sendExternalReferencesCommunication, createPushApplication, }) => {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [modalData, setModalData] = (0, react_1.useState)(null);
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenModal = (rowData) => {
        setModalData(rowData);
        setIsModalOpen(true);
    };
    const splitCustomerName = (customerName) => {
        const splitName = customerName.split(' ');
        const firstName = splitName[0];
        const lastName = splitName[splitName.length - 1];
        return {
            firstName,
            lastName,
        };
    };
    const handleResendSubmit = async (formValues) => {
        const { primaryPhone, locationId, uuid, customerName, applicationStatus } = formValues;
        const url = (0, config_1.makePath)(config_1.CONSUMER_APP_URL, config_1.APPLICATION_FINDER_URL);
        const requestData = {
            applicationCallbackUrl: url,
            sms: primaryPhone,
            template: config_1.RESEND_APPLICATION_SMS_TEMPLATE_NAME,
        };
        if (applicationStatus === 'Application Link Sent') {
            const { firstName, lastName } = splitCustomerName(customerName);
            const newCreditApplication = {
                location_id: locationId,
                firstName: firstName,
                lastName: lastName,
                dateOfBirth: '',
                primaryPhone: primaryPhone,
            };
            return createPushApplication(newCreditApplication).then((creditApplictionResponse) => {
                const { creditApplication: { applicationId }, } = creditApplictionResponse;
                const pushAppUrl = (0, config_1.makePath)(config_1.CONSUMER_APP_URL, config_1.PATH.CREDIT_PORTAL, config_1.PATH.APPLICANTS, config_1.PATH.PUSH_APPLICATION);
                const requestData = {
                    applicationCallbackUrl: pushAppUrl,
                    sms: primaryPhone,
                    template: config_1.PUSH_APPLICATION_SMS_TEMPLATE_NAME,
                };
                return sendExternalReferencesCommunication(applicationId, requestData)
                    .then((tokenResponse) => {
                    return {
                        token: tokenResponse,
                        applicant: creditApplictionResponse.applicant,
                    };
                })
                    .catch((e) => {
                    if (e?.response?.errorCode === 'patient_sms_opt_out' ||
                        e?.response?.errorCode === 'exceeds_retry_limit') {
                        (0, utils_1.reportError)('flashError', {
                            componentName: 'ApplicationActivityTable',
                            funcName: 'sendExternalReferencesCommunication',
                            errType: 'prequal',
                            errCode: e?.response?.errorCode,
                            errURL: window.location.pathname,
                            errMsg: e.response.message,
                            errData: applicationStatus,
                            errLocationId: locationId,
                            errCustomer: customerName,
                        }, e);
                        return (0, utils_1.toastError)(e.response.message);
                    }
                    (0, utils_1.reportError)('flashError', {
                        componentName: 'ApplicationActivityTable',
                        funcName: 'sendExternalReferencesCommunication',
                        errType: 'prequal',
                        errCode: e?.response?.errorCode,
                        errURL: window.location.pathname,
                        errMsg: e.response.message,
                        errData: applicationStatus,
                        errLocationId: locationId,
                        errCustomer: customerName,
                    }, e);
                    return (0, utils_1.toastError)(`We were unable to text message
            ${creditApplictionResponse.applicant.firstName} ${creditApplictionResponse.applicant.lastName} at ${creditApplictionResponse.applicant.primaryPhone}.
            Please ensure that the Patient has a working mobile phone number.`);
                });
            });
        }
        else if (resendableStatuses.includes(applicationStatus)) {
            return sendExternalReferencesCommunication(uuid, requestData)
                .then((tokenResponse) => {
                return {
                    token: tokenResponse,
                    applicant: {
                        customerName: customerName,
                    },
                };
            })
                .catch((e) => {
                if (e?.response?.errorCode === 'patient_sms_opt_out' ||
                    e?.response?.errorCode === 'exceeds_retry_limit') {
                    (0, utils_1.reportError)('flashError', {
                        componentName: 'ApplicationActivityTable',
                        funcName: 'sendExternalReferencesCommunication',
                        errType: 'prequal',
                        errCode: e?.response?.errorCode,
                        errURL: window.location.pathname,
                        errMsg: e.response.message,
                        errData: applicationStatus,
                        errLocationId: locationId,
                        errCustomer: customerName,
                    }, e);
                    return (0, utils_1.toastError)(e.response.message);
                }
                const errMsg1 = `We were unable to text message
          ${customerName} at ${(0, utils_1.formatPhoneNumber)(primaryPhone)}.
          Please ensure that the Patient has a working mobile phone number.`;
                (0, utils_1.reportError)('flashError', {
                    componentName: 'ApplicationActivityTable',
                    funcName: 'sendExternalReferencesCommunication',
                    errType: 'prequal',
                    errCode: e?.response?.errorCode,
                    errURL: window.location.pathname,
                    errMsg: errMsg1,
                    errData: applicationStatus,
                    errLocationId: locationId,
                    errCustomer: customerName,
                }, e);
                return (0, utils_1.toastError)(errMsg1);
            });
        }
        else {
            const errMsg2 = 'Invalid Status for Resending';
            (0, utils_1.reportError)('flashError', {
                componentName: 'ApplicationActivityTable',
                funcName: 'sendExternalReferencesCommunication',
                errType: 'prequal',
                errCode: 'invalid_status',
                errURL: window.location.pathname,
                errMsg: errMsg2,
                errData: applicationStatus,
                errLocationId: locationId,
                errCustomer: customerName,
            });
            return (0, utils_1.toastError)(errMsg2);
        }
    };
    const handleResendSuccess = (response) => {
        const name = response.customerName ??
            `${response.applicant.firstName} ${response.applicant.lastName}`;
        (0, utils_1.toastSuccess)(`We have successfully sent an SMS with an application link to ${name}. `);
        setIsModalOpen(false);
    };
    const statusColorMap = {
        Declined: 'red',
        Approved: 'green',
        Pending: 'orange',
    };
    const resendableStatuses = [
        'Application Link Sent',
        'PreQualified, Needs to Complete Application',
        'Pending - Step Up Verification',
    ];
    const columns = [
        {
            header: 'Customer',
            accessorKey: 'customerName',
            enableColumnFilter: true,
        },
        {
            header: 'Product Type',
            accessorKey: 'programProductType',
            accessorFn: (row) => (0, utils_1.formatProgramProductType)(row.programProductType ?? ''),
            enableColumnFilter: true,
        },
        {
            header: 'Amount',
            accessorKey: 'displayAmount',
            accessorFn: (row) => (0, utils_1.formatCurrency)(row.displayAmount, 2),
            enableColumnFilter: false,
        },
        {
            header: 'AppDate',
            accessorKey: 'createdAt',
            enableColumnFilter: false,
            accessorFn: (row) => (0, utils_1.formatISODateStringAsUSMonthDayYear)(row.createdAt),
        },
        {
            header: 'Status',
            accessorKey: 'applicationStatus',
            enableColumnFilter: true,
            cell: (props) => {
                return ((0, jsx_runtime_1.jsx)("span", { className: "wrap-span", style: {
                        color: statusColorMap[props.getValue()],
                    }, children: props.getValue().toUpperCase() }));
            },
        },
        {
            header: 'Action',
            enableColumnFilter: false,
            cell: (props) => {
                const rowData = props.row.original;
                return ((0, jsx_runtime_1.jsx)("span", { className: "actions", children: rowData.applicationStatus !== 'Declined' &&
                        rowData.accountNumber ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AuthorizedLink_1.default, { to: `${config_1.ACCOUNT_DETAIL_URL}${rowData.accountNumber}`, requiredPermission: config_1.PERMISSION.ACCOUNT_LOOKUP, children: "VIEW" }), rowData.lenderName != 'Covered Care' && ((0, jsx_runtime_1.jsx)(AuthorizedLink_1.default, { to: {
                                    pathname: `${config_1.SALES_URL}/${rowData.accountNumber}`,
                                    state: {
                                        alphaeonAccountNumber: rowData.alphaeonAccountNumber,
                                        availableCreditLimit: rowData.amount,
                                        address: {},
                                        name: rowData.name,
                                    },
                                }, requiredPermission: config_1.PERMISSION.PROCESS_SALE, children: "PROCESS SALE" }))] })) : resendableStatuses.includes(rowData.applicationStatus) ? ((0, jsx_runtime_1.jsx)("button", { onClick: () => {
                            handleOpenModal(rowData);
                        }, className: "resend-app-button", children: "RESEND" })) : ('_') }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Modal, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, onRequestClose: handleCloseModal, contentClassName: "resend-app-modal-content", children: (0, jsx_runtime_1.jsx)(forms_1.ResendApplicationForm, { data: modalData, onSubmit: handleResendSubmit, onSubmitSuccess: handleResendSuccess }) }), (0, jsx_runtime_1.jsx)(components_1.Table, { data: data, columns: columns })] }));
};
function mapStateToProps() {
    return {};
}
const mapApiAuthToProps = {
    createPushApplication: apiActions.createPushApplication,
    sendExternalReferencesCommunication: apiActions.sendExternalReferencesCommunication,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(ApplicationActivityTable);
